export const CWtwSlidesFragments = {
  field: `
    fragment wtwSlides on wtwSlides_MatrixField {
      ... on wtwSlides_slide_Entry {
        id
        typeHandle
        layout
        label
        heading
        subheading
        copy
        animationFile {
          url
          title
        }
      }
    }
  `,
}
